import { HELPED_KEY } from '../const';

export const UPDATE_STATS = 'TM UPDATE STATS';
export const SET_OPTIONS = 'TM SET OPTIONS';
export const SELECT_SIZE = 'TM SELECT SIZE';
export const SET_LEVELS_COMPLETED = 'TM SET LEVELS COMPLETED';
export const SET_LEVEL = 'TM SET LEVEL';
export const SET_START_LEVEL = 'TM SET START LEVEL';
export const SET_TIME_LEFT = 'TM SET TIME LEFT';
export const SET_SCORE = 'TM SET SCORE';
export const SET_INTRODUCED = 'TM SET INTRODUCED';
export const LOADING_GAME = 'TM LOADING GAME';
export const SHOW_INTRO = 'TM SHOW INTRO';
export const SET_SHAPES = 'TM SET SHAPES';
export const PAUSE = 'TM PAUSE';

export const selectSize = size => ({ type: SELECT_SIZE, size });
export const setLevelsCompleted = levelsCompleted => ({ type: SET_LEVELS_COMPLETED, levelsCompleted });
export const setLevel = level => ({ type: SET_LEVEL, level });
export const setStartLevel = startLevel => ({ type: SET_START_LEVEL, startLevel });
export const setTimeLeft = timeLeft => ({ type: SET_TIME_LEFT, timeLeft });
export const setScore = (steps, score) => ({ type: SET_SCORE, payload: { steps, score } });
export const setIntroduced = introduced => ({ type: SET_INTRODUCED, introduced });
export const updateStats = stats => ({ type: UPDATE_STATS, stats });
export const setOptions = options => ({ type: SET_OPTIONS, options });
export const setLoadingGame = on => ({ type: LOADING_GAME, on });
export const showIntro = show => ({ type: SHOW_INTRO, show });
export const setShapes = shapes => ({ type: SET_SHAPES, shapes });
export const pause = on => ({ type: PAUSE, on });
export const setHelped = () => ({ type: HELPED_KEY });
